import { render, staticRenderFns } from "./TemplateEditor.vue?vue&type=template&id=af3bafd8&scoped=true&"
import script from "./TemplateEditor.vue?vue&type=script&lang=js&"
export * from "./TemplateEditor.vue?vue&type=script&lang=js&"
import style0 from "./TemplateEditor.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TemplateEditor.vue?vue&type=style&index=1&id=af3bafd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3bafd8",
  null
  
)

export default component.exports